import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import BreadcrumbsArticle from "../../components/navigation/BreadcrumbsArticle";
import HeroArticle from "../../components/hero/HeroArticle";
import {SeoHelper} from "../../components/helpers/SeoHelper";

const WorshipHub = () => {
    return (
        <>
            <SeoHelper
                uri = "/worship/worship-guidance-and-planning"
                title = "Worship Guidance and Planning"
                description="Scripture-centred guidance to help you begin and plan worship."
            />

            <HeroArticle
                title="Worship Guidance & Planning"
                subtitle="Scripture-centred guidance to help you begin and plan worship."
            />

            <BreadcrumbsArticle
                items={[
                    { label: "Home", href: "/" },
                    { label: "Worship" }
                ]}
            />

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg="8" className="article-content">

                            <p>
                                Worship takes many forms — personal and communal, planned and spontaneous.
                                Whether you are beginning your journey or preparing worship for others,
                                The Worship Bible helps root worship in Scripture and shape it naturally
                                through song and prayer.
                            </p>

                            <h2>Begin Worship</h2>
                            <p>
                                If you are longing to worship God but are unsure where to start,
                                these pages offer gentle guidance and a place to begin.
                            </p>

                            <ul>
                                <li>
                                    <strong>
                                        <Link to="/worship/i-want-to-worship">
                                            I Want to Worship
                                        </Link>
                                    </strong>
                                    <br />
                                    A gentle starting point for those seeking to worship God but unsure where to begin.
                                </li>
                                <li>
                                    <strong>
                                        <Link to="/worship/worship-songs-by-bible-passage">
                                            Worship Songs by Bible Passage
                                        </Link>
                                    </strong>
                                    <br />
                                    Discover worship songs shaped by specific passages of Scripture.
                                </li>
                            </ul>

                            <h2>Plan Worship</h2>
                            <p>
                                For worship leaders, pastors, and planners, these resources help shape
                                worship services that flow from Scripture with clarity and confidence.
                            </p>

                            <ul>
                                <li>
                                    <strong>
                                        <Link to="/worship/plan-worship-for-your-next-service">
                                            Plan worship for your next Service
                                        </Link>
                                    </strong>
                                    <br />
                                    Guidance for preparing an upcoming worship service.
                                </li>
                                <li>
                                    <strong>
                                        <Link to="/worship/worship-planning-using-the-lectionary">
                                            Worship Planning Using the Lectionary
                                        </Link>
                                    </strong>
                                    <br />
                                    Explore worship planning rooted in the Church’s lectionary calendar.
                                </li>
                                <li>
                                    <strong>
                                        <Link to="/worship/help-creating-a-worship-list">
                                            Help Creating a Worship List
                                        </Link>
                                    </strong>
                                    <br />
                                    Support in choosing and ordering songs for meaningful worship.
                                </li>
                            </ul>

                            <p className="mt-4">
                                You don’t need to use everything at once.
                                Begin where you are, and let worship grow naturally.
                            </p>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default WorshipHub;